import { Grid, GridItem, GridProps } from '@chakra-ui/react';
import React from 'react';
import { Text } from './Typography';

export interface KeyValueGridProps extends GridProps {
    items: { key: string; value: string | JSX.Element }[];
}

export default function KeyValueGrid({ items, ...props }: KeyValueGridProps) {
    return (
        <Grid templateColumns="auto auto" alignItems="center" {...props}>
            {items.map(({ key, value }, idx) => {
                const gridItemProps = {
                    h: 'full',
                    pt: idx === 0 ? 0 : 3,
                    pb: idx === items.length - 1 ? 0 : 3,
                    borderBottomWidth: idx === items.length - 1 ? 0 : 1,
                    borderColor: 'border',
                };
                return (
                    <React.Fragment key={key}>
                        <GridItem
                            {...gridItemProps}
                            pr={6}
                            display="flex"
                            alignItems="center"
                        >
                            <Text fontWeight="medium">{key}</Text>
                        </GridItem>
                        <GridItem {...gridItemProps}>
                            {typeof value === 'string' ? (
                                <Text>{value}</Text>
                            ) : (
                                value
                            )}
                        </GridItem>
                    </React.Fragment>
                );
            })}
        </Grid>
    );
}
